import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import helpIcon from "./icons/help_icon.gif";

const toastOptions = {
  position: "bottom-right",
  className: "note-background",
  autoClose: false,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

const CustomeToast = ({ msg }) => {
  return (
    <div className="flex">
      <img
        className="w-12 h-12 rounded-full mr-4"
        src={helpIcon}
        alt="Help icon"
      />
      <div className="text-sm">
        <p className="text-gray-900 leading-relaxed font-bold">{msg}</p>
      </div>
    </div>
  );
};

const displayToast = (msg, id) => {
  toast.success(<CustomeToast msg={msg} />, {
    ...toastOptions,
    toastId: id,
  });
};

const displayRequestInforToast = () => {
  toast.dismiss("help-notification-1");
  toast.dismiss("help-notification-2");
  toast.dismiss("help-notification-3");
  displayToast(
    "Use the options in the Requested Information box above to select the data you want to see or download",
    "help-notification-4"
  );
};

const HelpToaster = () => {
  useEffect(() => {
    displayToast(
      "Use the dropdown menus on the left to switch between different zones, local authorities or pollutants",
      "help-notification-1"
    );

    displayToast(
      "You can also click directly on the map or enter an address or post code in the search box above.  Summary information and options to get data will appear",
      "help-notification-2"
    );

    displayToast(
      "Choose a Basemap that you prefer using the menu next to the map",
      "help-notification-3"
    );
  }, []);

  return <ToastContainer icon={false} />;
};

export { HelpToaster, displayRequestInforToast };
